module.exports = __webpack_public_path__ + "img/robot2.01a5e9ce.png";